import type { FieldError } from "react-hook-form";

import type { FormData, ValidationRule } from "../types";
import {
  type Ctx,
  type IntegrationType,
  type ValidatorFn,
  validators,
} from "./dnsValidators";

export const getErrorMessage = (
  error: FieldError | undefined,
  fallback: string = "",
) => error?.message || fallback;

// for react-hook-form
export function buildValidationRules(opts: {
  getType: () => string;
  integrationType: IntegrationType;
  isDuplicate: () => boolean;
}): Record<keyof FormData, ValidationRule> {
  const ctx: Ctx = {
    getType: opts.getType,
    integrationType: opts.integrationType,
    isDuplicate: opts.isDuplicate,
  };

  const out = {} as Record<keyof FormData, ValidationRule>;

  (Object.keys(validators) as (keyof FormData)[]).forEach((key) => {
    const fn = validators[key] as ValidatorFn<FormData[typeof key]> | undefined;
    out[key] = fn
      ? { validate: (value: FormData[typeof key]) => fn(value, ctx) }
      : {};
  });

  return out;
}

// for import
export function validateImportedRecord(
  record: Partial<FormData>,
  ctx: {
    getType: () => string;
    integrationType: IntegrationType;
    isDuplicate: () => boolean;
  },
) {
  const errors: Record<string, string> = {};

  // validate only exising fields
  const fields: (keyof FormData)[] = Object.keys(record) as (keyof FormData)[];

  for (const key of fields) {
    const validator = validators[key] as
      | ValidatorFn<FormData[typeof key]>
      | undefined;
    if (!validator) continue;

    const res = validator(record[key], ctx);
    if (res !== true) errors[key] = res;
  }

  return errors;
}
